import React from 'react'
import { Redirect } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import Layout from '../../Layout'
import Error from '../../Error'
import EditHeader from '../../Edit/Header'
import Form from '../Form'
import initialValueDefaults from '../lib/initialValueDefaults'
import mutation from './lib/mutation'
import update from './lib/update'

export default () => {
  const [mutate, mutationProps] = useMutation(mutation, {
    update,
  })

  return (
    <Layout>
      <EditHeader>New gateway</EditHeader>

      <Form
        initialValues={initialValueDefaults}
        onSubmit={(data) => mutate({ variables: { data } })}
      />
      {mutationProps.error && <Error leftAligned />}
      {mutationProps.data && <Redirect to='/gateways' />}
    </Layout>
  )
}
